import { navigateExternalRoute } from '@core/utils/route';
import BottomNavigation from '@mui/material/BottomNavigation';
import BottomNavigationAction from '@mui/material/BottomNavigationAction';
import { FC, memo, useCallback } from 'react';

import { SOCIAL_MEDIA } from '../assets/data/social-media';

const FooterSocial: FC = () => {
  const handleClick = useCallback((url: string) => navigateExternalRoute(url), []);

  return (
    <BottomNavigation sx={{ marginTop: '2.5rem' }}>
      {Object.values(SOCIAL_MEDIA).map(({ icon, url }) => (
        <BottomNavigationAction icon={icon} key={url} onClick={() => handleClick(url)} />
      ))}
    </BottomNavigation>
  );
};

export default memo(FooterSocial);
